export default function PixelPajamaMugLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      className="rounded-full"
    >
      <title>Pixel Pajama Studios Logo</title>
      <rect
        x="-47.57"
        y="-53.7"
        width="608.17"
        height="598.98"
        fill="#f37423"
      />
      <path
        d="M426.3,178.82c-6.15-6.31-23.75-12.55-42.32-12a122.1,122.1,0,0,0,.49-13.76,78.89,78.89,0,0,0-.76-11,18.63,18.63,0,0,0-.59-2.65c-.89-1.92-5.13-5.5-9-8.07-15.26-10-42.88-17.84-67-20.87-50.86-6.38-119.48-6-158.58,3.32-41.54,9.85-52.95,21.73-54.32,27.8s33.6,236.1,55.52,269.35c10.31,15.66,66.66,22.86,113.74,21.31,0,.06,12.37-1.13,26.41-3.32,16.63-2.59,35.59-6.57,39-11.52.24-.34.49-.76.75-1.2,2.76-4.58,6.44-14.93,10.58-29.05,14.64,3.1,42.16,6,52.67-12.89a2.12,2.12,0,0,0,.11-.21l.12-.19c.28-.5.54-1.07.85-1.63,13.73-25.25,31.13-86.83,39.35-157.21C434.59,203.77,435.06,187.82,426.3,178.82Z"
        fill="#3bc1cb"
      />
      <path
        d="M161.21,113.41c-7.94,1.17-20.32,3.52-26,6.91s.44,5.88,5.39,3.77c5.8-2.47,27.35-5.87,27.35-5.87s9.28-.15,8.84-4C176.38,110.82,166.67,112.6,161.21,113.41Z"
        fill="#b8e3ea"
      />
      <path
        d="M184.86,110.07c-1.83.28-3.33,1.13-2.88,2.72s4,2.2,6,1.75c1.8-.41,2.88-1.61,1.83-3.15S186.69,109.79,184.86,110.07Z"
        fill="#b8e3ea"
      />
      <path
        d="M132.85,154.31c-8.27-1.66-17.5-6.19-19-8.8s-1.1-5.65.54-7.21,5.48-3.87,11-6a219.14,219.14,0,0,1,32.6-8.08c17.76-3.12,40-5.15,60.37-5.92,37.93-1.43,53.25-.56,74.15,1.66,15.85,1.69,35.06,4.27,51,9.5,5.95,2,19.55,8.21,17.81,13.22-1.32,3.82-7,4.88-10.76,6.23-3.89,1.41-17.95,2.46-20.29,2.37"
        fill="#309cb5"
      />
      <path
        d="M128.21,150.55c13.74-25.07,219.23-24.55,221.35-3C350.86,160.72,120.38,164.86,128.21,150.55Z"
        fill="#653614"
      />
      <path
        d="M425.94,178.94c-4.8-4.93-16.6-9.8-30.39-11.44a82.2,82.2,0,0,0-11.93-.55,127.13,127.13,0,0,0,.49-13.76c0-1.8-.36-11.47-1.35-13.63.76,9-6.38,23.57-83.22,31.65a6.7,6.7,0,0,0-6,6.85c2.08,71.52-4.7,160.1-15.41,253.92,16.64-2.58,45.73-6.16,49.84-13.24.22-.37,1-1.94,1.25-2.38,2.76-4.58,6.43-14.92,10.58-29.05,14.64,3.1,42.16,6,52.67-12.89a2.12,2.12,0,0,0,.11-.21l.12-.19c.28-.5.54-1.07.85-1.63,13.73-25.25,31.13-86.83,39.35-157.21C434.23,203.89,434.7,187.94,425.94,178.94Z"
        fill="#309cb5"
      />
      <path
        d="M406.44,382.46c13.73-25.25,35-93.24,37.49-164.06,1.2-34.68-5.2-32.18-14-41.18-4.8-4.93-20.26-8.2-34-9.84a82.34,82.34,0,0,0-11.94-.55,122.1,122.1,0,0,0,.49-13.76c0-1.8.73-3.07-.26-5.23.76,9-.88,17.9-41,25.61-3.43.66-6.09,3.35-6,6.84,2.07,71.52-20,205.38-29,247.12,8.35.64,21.09-6.78,21.35-7.22,2.76-4.58,6.93-17.78,11.08-31.91,14.63,3.11,47.19,14.09,59.39.6Z"
        fill="#2a8493"
      />
      <path
        d="M104.32,173.6c-4.08,10.75,40.22,274.23,52.33,214.64-16.52-68.83-30.13-137-44.25-206.36C111.35,179,107.65,169.24,104.32,173.6Z"
        fill="#6dcad1"
      />
      <path
        d="M139.32,174.45c-1.69,1.32-1.75,2.32-1.54,8.55,1.57,45.66,35.15,238.36,41.51,243.45,7.22,5.78,46.23,11.07,59.72,12.52s36.12-2.41,37.56-3.86a3.78,3.78,0,0,1,3.37-1L305,269.93s7.7-100.18-1-99.21c-6.13.68-34,5.51-87.17,6-20.6.2-52.27-1.62-69.17-2.76C144,173.73,141,173.13,139.32,174.45Z"
        fill="#30a3c1"
        opacity="0.46"
      />
      <path
        d="M273.14,223.48c-7.15-7.52-13.76,1-20.42,1.69s-20.53-3.39-32.35.21c-8.93,2.72-24.84,18.71-30.46,30.52s-24.74,14.43-27.49,35.63,18.83-8.82,19.37,4.48,8,32.54,13.61,39.33c3.62,4.39,14.72,16.48,24.94,20.8,2.54,1.07,5.89,2.85,7.17,5.72,2.3,5.15,8,8.78,10.82,9.8,7.11,2.55,17.57,4.36,18.59.7-4.33-4.1-9.08-8.8-11.2-12.4-1-3.2-2.1-7.51.5-10.91,3.46-2.57,10.38-4.76,18.53-5.73.1-4-9.52-8.66-17.06-8.41s-10.58,8.9-16.75,2.67c-6.77-6.82-1.4-23.14,3.38-34,2.82-6.43,6.92-13.17,8.7-11.3a49.66,49.66,0,0,1,6.41,9.47c1.63,3,5.33-1.3,6.93-5.43s2.2-10.88,1-16.81c-.66-3.31-4.91-10-4.91-10a99.37,99.37,0,0,1,6-8.27c2.28-2.6,10.79-23.64,13.52-26.23S276.16,226.66,273.14,223.48Z"
        fill="#35adc1"
      />
      <path
        d="M234.54,235.78c0-.15,0-.3-.08-.47-.23-1.08.23-1.68-.39-2.1-.45-.3-1.5,0-2.58.16a6.49,6.49,0,0,0-8,4,7,7,0,0,0,1.23,7.4c.18,1,.05,2,.5,2a7.78,7.78,0,0,0,3.06-.22,6.63,6.63,0,0,0,6.78-4.27A7.06,7.06,0,0,0,234.54,235.78Z"
        fill="#383458"
      />
      <path
        d="M234.26,243.14c-.61,2-4.22,3.89-6.63,3-2.94-1.11-4.15-4.6-2.69-7.8a7.15,7.15,0,0,1,3.9-3.59"
        fill="#fff"
      />
      <ellipse
        cx="226.45"
        cy="254.63"
        rx="4.1"
        ry="6.6"
        transform="translate(-33.9 474.48) rotate(-88.53)"
        fill="#f79252"
      />
      <ellipse
        cx="226.34"
        cy="255.35"
        rx="3.37"
        ry="6.51"
        transform="translate(-34.73 475.07) rotate(-88.53)"
        fill="#f38eb6"
      />
      <path
        d="M227.47,241.4l-.95,3a5.36,5.36,0,0,0,4.18,1.12l-1-3.49Z"
        fill="#f2e575"
      />
      <path
        d="M227.59,240.91l-.15.51,2.28.64,0-.13,1.14-1.18,4.27,1.17a6,6,0,0,0,.36-1.84,5.58,5.58,0,1,0-11.16-.29s0,.05,0,.07l2.79-1.15Z"
        fill="#6c3672"
      />
      <path
        d="M229.68,241.93l0,.13,4.59,1.28a5.77,5.77,0,0,0,.78-1.42l-4.27-1.17Z"
        fill="#cd4f69"
      />
      <path
        d="M234.31,243.34l-4.59-1.28,1,3.48A5.54,5.54,0,0,0,234.31,243.34Z"
        fill="#cd4f69"
      />
      <path
        d="M224.33,240.56a5.68,5.68,0,0,0,2.21,3.92l.9-3.06Z"
        fill="#f79252"
      />
      <path
        d="M227.59,240.91l-.5-2.2-2.79,1.15a4.06,4.06,0,0,0,0,.7l3.11.86Z"
        fill="#f79252"
      />
      <ellipse
        cx="229.38"
        cy="239.44"
        rx="3.44"
        ry="3.72"
        transform="translate(-15.86 462.61) rotate(-88.53)"
        fill="#383458"
      />
      <ellipse
        cx="230.8"
        cy="237.49"
        rx="1.95"
        ry="2.5"
        transform="translate(-10.59 10.77) rotate(-2.61)"
        fill="#fff"
      />
      <ellipse
        cx="226.33"
        cy="239.74"
        rx="2.42"
        ry="2.16"
        transform="translate(-76.45 370.22) rotate(-69.96)"
        fill="#fff"
      />
      <path
        d="M271.31,222.88c-6.71,5.37-8.95,9.3-11.87,13.65s-4.07,8.34-6.29,10.7c-1.94,2.05-3.25,2.66-5.49,2.51"
        fill="none"
        stroke="#16556d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.31"
      />
      <path
        d="M272.61,235.54c2.72-2.59,4.2-8.31,1.18-11.49a15,15,0,0,0-1.12-1c-7.1,4.73-14.95,15.27-17.85,20.94-3.73,7.28-6,4.86-8.72,6s-6.72,8.55-9.8,13.63c-9.87,16.29-17.68,32.92-19.58,61.23s9.07,26.22,13.08,31.05c3.77,4.53,2.17,15.17,25.95,15.36-3.78-3.65-7.55-7.56-9.38-10.66-1-3.2-2.1-7.51.5-10.91,3.46-2.57,10.38-4.76,18.53-5.73.1-4-9.52-8.66-17.06-8.41s-10.58,8.9-16.76,2.67c-6.76-6.82-1.39-23.14,3.39-34,1.9-4.33,4.38-8.79,6.34-10.68,1.75-5.08,5.61-11.64,7.94-16.42,1.49-3.07,4-8.37,7.24-11.91.9-1.24,1.83-2.47,2.6-3.35C261.37,259.18,269.88,238.13,272.61,235.54Z"
        fill="#89ceb0"
      />
      <path
        d="M249,278.05c-2.32,4.79-5.31,11.17-7.69,15.4.95-.91,1.78-1.23,2.36-.62a49.66,49.66,0,0,1,6.41,9.47c1.63,3.05,5.33-1.3,6.93-5.43s2.2-10.87,1-16.81c-.66-3.31-4.91-10-4.91-10Z"
        fill="#298976"
      />
      <path
        d="M251.53,273.64c1.86,1.74,2.37,4.43,2.92,6.82a45.81,45.81,0,0,1,1.16,8.72c.14,5-.48,10.74-4,14.57-1.33,1.43,1.83,1.54,2.64.66,3.86-4.18,4.76-10,4.64-15.48a46.51,46.51,0,0,0-1.12-9.11c-.59-2.61-1.18-5.6-3.22-7.5-.9-.84-4,.42-3,1.32Z"
        fill="#35adc1"
      />
      <path
        d="M268.09,220.43a3.68,3.68,0,0,1,3.55,2.31l.4,0c1.24,0,1.33.65,1.75,1.33,1,1.62,1.54,8.9-1.18,11.49s-11.24,23.64-13.52,26.23a99.37,99.37,0,0,0-6,8.27s4.25,6.71,4.91,10c1.18,5.94.56,12.71-1,16.81-1.22,3.16-3.68,6.45-5.5,6.45a1.63,1.63,0,0,1-1.43-1,56.48,56.48,0,0,0-6.91-10.14,41,41,0,0,0-8.2,12c-4.78,10.88-10.15,27.2-3.39,34,1.63,1.64,3,2.25,4.38,2.25,3.72,0,6.83-4.74,12.38-4.92h.59c7.44,0,16.57,4.54,16.47,8.42-8.15,1-15.07,3.16-18.53,5.73-2.6,3.4-1.53,7.71-.5,10.91,2.12,3.6,6.87,8.3,11.2,12.4-.41,1.49-2.38,2.07-5,2.07A44.84,44.84,0,0,1,239,372.23c-2.82-1-8.52-4.65-10.82-9.8-1.28-2.87-4.63-4.65-7.17-5.72-10.22-4.32-21.32-16.41-24.94-20.8-5.58-6.79-13.06-26-13.61-39.33-.1-2.6-1-3.54-2.38-3.54-3.7,0-10.78,6.89-14.61,6.89-2,0-3.15-1.93-2.38-7.83,2.75-21.2,21.87-23.81,27.49-35.62S212.09,228.67,221,226a39.14,39.14,0,0,1,11.42-1.5c7.36,0,14.42,1.38,19.12,1.38.65,0,1.25,0,1.81-.08,4.48-.49,10.58-5.32,14.72-5.32m0-12.57h0c-5.06,0-9.5,2.17-13.08,3.91-1,.49-2.5,1.22-3.25,1.48h-.2c-1.42,0-3.71-.25-6.15-.51a121,121,0,0,0-13-.88,51.15,51.15,0,0,0-15.09,2c-13.49,4.12-31.59,23.36-38.15,37.16-.86,1.81-3.88,4.12-7.09,6.56-7.62,5.82-19.14,14.62-21.51,32.83-.63,4.79-.92,11.77,3.72,17a14.62,14.62,0,0,0,11.13,5,18.11,18.11,0,0,0,6.55-1.3c3.12,13,9.09,26.31,14.34,32.69,2.49,3,15.62,18.41,29.76,24.39a13.26,13.26,0,0,1,1.2.57c4.44,8.62,12.93,13.59,17.43,15.2,2.29.83,10.35,3.52,17.79,3.52,13,0,16.43-8.64,17.17-11.29a12.58,12.58,0,0,0-3.47-12.49c-2.6-2.46-4.67-4.53-6.2-6.17a53.44,53.44,0,0,1,6.87-1.25A12.58,12.58,0,0,0,278,344.21a16.34,16.34,0,0,0-5-12c-5.34-5.48-15.22-9.3-24-9.3h-1a22.67,22.67,0,0,0-6.46,1.17,62.23,62.23,0,0,1,3-10.06,14,14,0,0,0,7,1.88c8.57,0,14.52-7.49,17.23-14.5,2.54-6.59,3.18-15.93,1.62-23.79a30.5,30.5,0,0,0-2.43-6.8c.23-.29.43-.54.61-.74,2.06-2.35,3.6-5.48,7.83-14.57,1.71-3.68,4.51-9.7,5.72-11.68,6.6-7.29,6-20.14,2.56-26.1a14.12,14.12,0,0,0-5.8-5.9,16.2,16.2,0,0,0-10.76-4Z"
        fill="#fff"
      />
      <path
        d="M172.67,293.65c-1.79,1.22-5,3.66-7.21,4.2-1,.25-2-.05-1.39.83s1.39,1.48,1.91,1.39a18,18,0,0,0,5.16-2.44c1.3-1,7.18-4.16,7.61-4.88.3-.49,1.58-.17,2.56.39l1.35,2.56c.42,3.47.74,10.82,1,8.39.21-2.13.76-8,.85-9.58a73,73,0,0,1,4.26-20.64c.27-.73-1-.47-1.37-.43-.74.08-1.75,1.56-2,2.3-1.6,4.45-2.73,10.09-3.81,11.56S175,292.07,172.67,293.65Z"
        fill="#298976"
      />
      <path
        d="M270.05,221.19c-.43-.86-1.94-.86-4-.54s-6.25,3-9.05,4.2l-4.09,1.29a1.69,1.69,0,0,0-.23.66c-.75,0-1.51.08-2.21.06-2.83-.1-5.66-.37-8.47-.73-4.85-.62-10.21-2.14-15.13-1.56-11.73,1.39-25.18,12.87-31.29,22.33-1.32,2,1.48,3.7,3.12,2.4,5.38-4.27,10.65-10.62,16.77-15,4.4-3.19,9.3-4.36,14.89-4.46,5.35-.09,10.62.63,16,.8,2.35.08,7.24.51,9.42-1.41,3.5-1.21,6.59-4.39,9.9-5.86a24.94,24.94,0,0,1,4.82-1.52A2.31,2.31,0,0,1,270.05,221.19Z"
        fill="#53b460"
      />
      <path
        d="M186.58,261.22c-6.19,9.59-18.25,13.84-23.19,24.45-.79,1.7,2.5,1.76,3.13.41,2.35-5.06,6.66-8.67,10.91-12.11s8.83-7,11.89-11.74c1.13-1.75-1.9-2.32-2.74-1Z"
        fill="#53b460"
      />
      <path
        d="M269.71,221.55c-5.55-1.17-12.88,4.57-18.88,5.36-11.79-.85-27.07-6.85-39.89,6.23,6.79-5.22,14.63-5.68,23.58-5.54,5,.07,12,1.51,16.87,1.2,4.29-.27,8.22-3.09,12.06-4.81A43.25,43.25,0,0,1,269.71,221.55Z"
        fill="#89ceb0"
      />
      <path
        d="M237.14,225.41a30.88,30.88,0,0,0-5.17-.25,26,26,0,0,0-3.84.25,4.58,4.58,0,0,0-1.24.39c-.17.08-.59.28-.66.5-.19.56,1.11.36,1.3.32l-.21,0,.25,0c.22,0,.45,0,.67-.06l.88,0,.5,0H230c.78,0,1.55,0,2.33,0l1.18.06.56.05.28,0c-.18,0,.11,0,.14,0a4.09,4.09,0,0,0,2.28-.42c.21-.11.59-.26.67-.5s-.08-.33-.27-.35Z"
        fill="#e8eaee"
      />
      <path
        d="M248.22,338.74l.72-.09c-.92.18-.4,0-.13,0s.48,0,.72,0a1.63,1.63,0,0,0,.54,0q-.67,0-.21,0l.36,0,.54,0c.42.05.83.12,1.24.19s-.38-.1.1,0l.7.19c.4.11.8.25,1.19.4s.78.32,1.16.5c.17.08.33.15.49.24-.31-.16.3.18.36.21,1.27.76,3.15.35,4.45-.18a4.34,4.34,0,0,0,1.87-1.17c.22-.29.53-.85.07-1.13a19.64,19.64,0,0,0-13-2.33,8.25,8.25,0,0,0-2.6.84c-.42.23-1.19.69-1.35,1.23-.4,1.34,2.26,1.1,2.83,1Z"
        fill="#fff"
      />
      <path
        d="M266,220.69a35.39,35.39,0,0,0-4.29,1.86c-.33.16-.65.33-1,.5l0,0-.27.13-.6.28c-.88.41-1.75.82-2.6,1.27-.46.25-1,.91-.3,1.23a2.78,2.78,0,0,0,2.31-.31l.57-.3,0,0,.34-.16,1-.48c.81-.38,1.6-.78,2.38-1.2.2-.1-.26.13,0,0l.22-.11.46-.21,1-.47c.66-.28,1.32-.54,2-.78.41-.14,1.36-.75.88-1.27s-1.6-.2-2.15,0Z"
        fill="#e8eaee"
      />
      <path
        d="M273.79,224.05c-.47-.75-.52-1.45-2.15-1.31-3.08-6.35-12.18,2.35-18.27,3-6.67.71-20.53-3.4-32.35.2-8.93,2.72-24.84,18.71-30.46,30.53s-24.74,14.42-27.49,35.62,18.83-8.82,19.37,4.48,8,32.54,13.61,39.33c3.62,4.39,14.72,16.48,24.94,20.8,2.54,1.07,5.89,2.85,7.17,5.72,2.3,5.15,8,8.78,10.82,9.8,7.11,2.56,17.57,4.36,18.59.7-4.33-4.1-9.08-8.8-11.2-12.4-1-3.2-2.1-7.51.5-10.91,3.46-2.57,10.38-4.76,18.53-5.73.1-4-9.52-8.66-17.06-8.41s-10.58,8.9-16.76,2.67c-6.76-6.82-1.62-23.25,3.39-34,2.78-6,6.59-11.09,7.38-12.89a67.38,67.38,0,0,1,7.73,11.06c1.63,3.05,5.33-1.3,6.93-5.43s2.2-10.87,1-16.81c-.45-2.27-2.53-6.2-3.79-8.44a3.3,3.3,0,0,1,.08-3.39c1.12-1.79,15.56-30.1,18.29-32.69S274.78,225.67,273.79,224.05Z"
        fill="none"
        stroke="#16556d"
        strokeMiterlimit="10"
        strokeWidth="2.52"
      />
      <path
        d="M211.3,274.47c1.89,2.21,2,5.3,1.93,8.07a48.12,48.12,0,0,1-1.17,9.34,48.45,48.45,0,0,1-5,13.08q-.52.94-1.11,1.86c-.23.37-.46.74-.7,1.1-.1.15-.67.69-.27.52l1.31-.27h.16a2.86,2.86,0,0,0-2.36.35c-.42.25-1.05.87-.33,1.19,3.48,1.55,5.71-3.47,6.94-5.76a50.13,50.13,0,0,0,4.17-10.44,48.65,48.65,0,0,0,1.69-11.12c.11-3.21.06-6.63-2.14-9.19-.68-.81-3.89.36-3.12,1.26Z"
        fill="#89ceb0"
      />
      <path
        d="M214.59,286.44c-1.14,1.38-1.21,3.54-1.67,5.24-.56,2.05-1.65,4.05-1.77,6.19a1,1,0,0,0,1.76.72c1.48-1.7,1.9-4.11,2.3-6.28.32-1.79.91-4.16,0-5.79a.38.38,0,0,0-.58-.08Z"
        fill="#fff"
      />
      <path
        d="M211.05,269c.6,2.15,1.65,2.77,3,4.39,3.09,3.66,2.06,10.48,1.33,15a42.12,42.12,0,0,1-7.32,17.45c-1.87,2.68-3.87,3.33-5.9-.08a16,16,0,0,1-1.38-3.95c-.82-3-1.43-6-2-9.06-.77-4-1.9-8.32-1.28-12.39.9-5.88,4.48-5.25,7.35-8.85.55-.69-.42-1.68-1-1-2.79,3.49-6.42,3.11-7.55,8-1,4.47.15,9.38,1,13.79.67,3.63,1.94,17.55,7.62,17.92,2.57.16,4.61-4,5.63-5.73a41.36,41.36,0,0,0,6.73-25.85,10.65,10.65,0,0,0-.91-4.67c-1.21-2.18-3.21-2.58-4-5.35a.7.7,0,0,0-1.34.37Z"
        fill="#16556d"
      />
      <path
        d="M239.75,257.26c-4.39,2.86-7.17,8.3-9.77,12.68-3.25,5.47-6.37,11.05-8.23,17.15-3.79,12.41-4.14,25.93-5.17,38.77-.21,2.63,3.76,2.54,4.06,0,1.44-12.3,1.37-24.94,4.62-37,1.66-6.13,4.61-11.71,7.56-17.3,2.38-4.48,5.89-9.2,7.23-14.1a.21.21,0,0,0-.3-.24Z"
        fill="#a5cf5d"
      />
      <path
        d="M258,153.2c0-3.56,18.71-6.45,41.79-6.45,20.17,0,37,2.2,40.92,5.13a32,32,0,0,0,6.73-2.12c-8.8-7.72-60-11.11-111.83-7.8-22.62,1.79-44.77,7.21-48.4,13-1.36,2.18,5.69,3.65,17.92,4.54,22.27.18,46.53-.27,68.71-1.24C264.21,157.06,258,155.24,258,153.2Z"
        fill="#7c4f24"
      />
      <path
        d="M299.8,146.75c-23.08,0-41.79,2.89-41.79,6.45,0,2,6.2,3.86,15.84,5.05,28.82-1.28,54.1-3.46,66.87-6.37C336.79,149,320,146.75,299.8,146.75Z"
        fill="#a8824e"
      />
      <path
        d="M362.67,148.8c-.25.2-.52.37-.79.55-.83.58,1-.5.28-.15l-.51.28c-.46.24-.93.47-1.39.69s-2.35,1-.63.3c-1.21.48-2.41,1-3.63,1.44-.73.27-1.46.53-2.2.78-.38.14-.77.27-1.15.39s-1.75.46-.09,0c-1.62.41-3.21,1-4.82,1.41-.8.22-1.6.43-2.41.62l-1.5.36-.56.13.53-.12a9.38,9.38,0,0,1-2.63.52c-.87.16-1.74.3-2.62.43l-1.11.15c-.57.08-.48.07.26,0l-.72.08c-.83.08-1.65.14-2.48.19-2.36.13-5.64.86-7.3,2.68s1.49,2.15,2.66,2.08a98.41,98.41,0,0,0,24.06-4.82,112.72,112.72,0,0,0,11.1-4.1,27.23,27.23,0,0,0,6.1-3.3c.43-.34,1.44-1,1.24-1.77s-1.43-.88-2-.92c-2.4-.14-5.78.53-7.73,2.08Z"
        fill="#b8e3ea"
      />
      <path
        d="M372.18,139.49c-3.62.56-3.23,3.89-2.16,4.4s6.25.76,6.29-.92A3.51,3.51,0,0,0,372.18,139.49Z"
        fill="#b8e3ea"
      />
      <path
        d="M447.78,195.52l-1.18-.28A69.93,69.93,0,0,0,441,178.18l-37.49-15c-7.71,1.74-26,1.81-25.36,12.85,11.83,1.77,46.66,4,53.66,20.32,13.8,32.18-31.41,168.28-35.84,176.41-4.34,7.94-5.62,14.37-11.16,18.94.78,3.31,9.34-1.15,17.42-5C423,356.93,438.61,301.28,442,265.83,445.72,248.65,450.12,212.93,447.78,195.52Z"
        fill="#309cb5"
      />
      <path
        d="M233.67,106.21a608.57,608.57,0,0,1,73.4,4.29c24.13,3,51.75,10.89,67,20.87,3.91,2.57,8.15,6.15,9,8.07a18.63,18.63,0,0,1,.59,2.65,78.89,78.89,0,0,1,.76,11,122.1,122.1,0,0,1-.49,13.76l1.45,0c18.52,0,44.81,10.16,50.8,16.31,8.76,9,8.29,24.95,7,36.24-8.23,70.38-25.63,132-39.36,157.21-.31.56-1,2-1.08,2-5.43,9.75-18,12.54-31,12.54-12.12,0-24.54-2.45-31.62-3.95-4.14,14.12-7.82,24.47-10.58,29.05-.26.44-.51.86-.75,1.2-3.41,4.95-22.37,8.93-39,11.52-13.7,2.13-25.83,3.32-26.39,3.32h0c-4.19.14-8.45.2-12.75.2-44,0-91.59-7.24-101-21.51C127.77,377.72,92.8,147.68,94.17,141.62s12.78-18,54.32-27.8c21.9-5.2,53.06-7.61,85.18-7.61m0-16.35v0c-35.47,0-67.06,2.86-88.95,8-40.28,9.55-62.65,23-66.5,40.11-.72,3.22-1.25,5.54,4.8,46,2.3,15.42,7.19,46.95,14.09,85,6.5,35.89,12.75,66.34,18.57,90.52C125.72,401.26,132.11,414,136,420c7.14,10.83,22.41,18.19,48.07,23.16,19,3.68,42.65,5.7,66.57,5.7,4.47,0,8.94-.07,13.29-.21h0c3.51-.16,16.82-1.7,28.38-3.49,34.77-5.41,44.89-11.05,49.95-18.4.45-.65.89-1.35,1.38-2.19,1.63-2.73,4.05-7.54,7.79-18.67a141.14,141.14,0,0,0,20.32,1.63c9.07,0,17.06-1.19,23.74-3.54,9.63-3.4,17.08-9.41,21.53-17.4,0,0,.17-.31.37-.7l.78-1.47c16.63-30.58,33.59-97.66,41.23-163.12,1-8.34,3.94-33.69-11.5-49.55-7.93-8.14-28.6-16.4-47.14-19.72a90.66,90.66,0,0,0-.95-12.53,35.54,35.54,0,0,0-1.15-5l-.31-1-.43-.94c-2.81-6.06-9.67-11.43-14.94-14.88C363.29,104.78,330.87,97,309.1,94.28a627.85,627.85,0,0,0-75.43-4.42Z"
        fill="#16556d"
      />
      <path
        d="M355,343c-1.6.11-6.46,1.29-8.06,9.63a17.61,17.61,0,0,0,4.33,1.93,28.81,28.81,0,0,0,9.15.48c3.84-.4,7.77-3.79,9.39-5.72,2.25-2.68,4.75-7.17,4.58-7.89Z"
        fill="#309cb5"
      />
      <path
        d="M376.69,199.05c-3.56,33.79-26.91,146-26.91,146,6.76.93,21.77,5.73,28.41-9.64C390.47,307,398.5,274.6,402.75,237.9c1.93-16.61,2.5-26.81-.24-30.1C396.48,200.55,382.86,199.93,376.69,199.05Z"
        fill="#16556d"
      />
      <ellipse cx="292.95" cy="151.93" rx="8.19" ry="1.69" fill="#bfa36a" />
      <path
        d="M268.09,220.43a3.68,3.68,0,0,1,3.55,2.31l.4,0c1.24,0,1.33.65,1.75,1.33,1,1.62,1.54,8.9-1.18,11.49s-12.25,23-14.23,25.77-5.26,8.73-5.26,8.73,4.25,6.71,4.91,10c1.18,5.94.56,12.71-1,16.81-1.22,3.16-3.68,6.45-5.5,6.45a1.63,1.63,0,0,1-1.43-1,56.48,56.48,0,0,0-6.91-10.14,41,41,0,0,0-8.2,12c-4.78,10.88-10.15,27.2-3.39,34,1.63,1.64,3,2.25,4.38,2.25,3.72,0,6.83-4.74,12.38-4.92h.59c7.44,0,16.57,4.54,16.47,8.42-8.15,1-15.07,3.16-18.53,5.73-2.6,3.4-1.53,7.71-.5,10.91,2.12,3.6,6.87,8.3,11.2,12.4-.41,1.49-2.38,2.07-5,2.07A44.84,44.84,0,0,1,239,372.23c-2.82-1-8.52-4.65-10.82-9.8-1.28-2.87-4.63-4.65-7.17-5.72-10.22-4.32-21.32-16.41-24.94-20.8-5.58-6.79-13.06-26-13.61-39.33-.1-2.6-1-3.54-2.38-3.54-3.7,0-10.78,6.89-14.61,6.89-2,0-3.15-1.93-2.38-7.83,2.75-21.2,21.87-23.81,27.49-35.62S212.09,228.67,221,226a39.14,39.14,0,0,1,11.42-1.5c7.36,0,14.42,1.38,19.12,1.38.65,0,1.25,0,1.81-.08,4.48-.49,10.58-5.32,14.72-5.32m0-3v0c-2.85,0-5.91,1.5-8.88,2.94-2.23,1.09-4.54,2.22-6.16,2.39a13.07,13.07,0,0,1-1.49.07c-1.93,0-4.35-.26-7.16-.56a113.19,113.19,0,0,0-12-.82,41.67,41.67,0,0,0-12.29,1.63c-9.68,2.95-26.29,19.46-32.3,32.11-1.86,3.9-5.6,6.75-9.92,10.06-7.12,5.44-16,12.2-17.84,26.46-.62,4.74-.18,7.67,1.42,9.49a5.11,5.11,0,0,0,3.94,1.73c2.8,0,5.83-1.92,9-4a34.05,34.05,0,0,1,4.93-2.78c0,.14,0,.31,0,.51.56,13.85,8.28,33.81,14.29,41.12.55.66,13.55,16.35,26.09,21.65,3.79,1.6,5.13,3.16,5.59,4.18,2.69,6,9,10.12,12.55,11.4,4,1.43,9.87,2.95,14.55,2.95,5.58,0,7.4-2.32,7.94-4.27a3,3,0,0,0-.83-3c-4.09-3.87-8.51-8.24-10.51-11.46-.85-2.73-1.39-5.48-.09-7.52,3.22-2.18,9.55-4,16.73-4.9a3,3,0,0,0,2.64-2.9,7,7,0,0,0-2.3-5.09c-3.56-3.65-11-6.41-17.17-6.41h-.69c-3.82.13-6.62,1.89-8.87,3.3-1.33.83-2.58,1.62-3.41,1.62a3.74,3.74,0,0,1-2.25-1.36c-4.18-4.21-2.72-15.41,4-30.71a38,38,0,0,1,5.33-8.56,62.85,62.85,0,0,1,4.39,7,4.61,4.61,0,0,0,4.08,2.6c4,0,7.09-5.26,8.3-8.37,1.9-4.94,2.37-12.37,1.16-18.48-.56-2.82-3-7.12-4.38-9.5,1.08-1.9,3-5.12,4.23-6.91.86-1.2,2.43-4.25,5.12-9.53,2.58-5.05,7.38-14.47,8.74-15.82,3.95-3.75,3.2-12.73,1.66-15.23a1.74,1.74,0,0,1-.1-.19,4.41,4.41,0,0,0-2.88-2.41,6.56,6.56,0,0,0-5.27-2.45Z"
        fill="#16556d"
      />
      <path
        d="M254.91,268.71c-2.69,5.49-8.4,15.71-13.73,26.1"
        fill="none"
        stroke="#6c3672"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
    </svg>
  );
}
